import { createReducer, createSelector } from 'redux-starter-kit';
import { putEmailContent, putAllEmailContent, addDefaultContent } from './emailActions';
/**
 * A selector for email content in the domain.
 * @param {object} state The redux state for the application.
 * @param {string} emailType The email Type to retrieve the content for
 */
export const selectEmailContent = (state, emailType) => state.via.domain.emails[emailType];

/**
 * A selector for all the email content in the domain
 * @param {object} state The redux state
 * @returns A map of email type to the email content object { emailType:..., emailContent:... }
 */
export const selectEmailContentMap = state => state.via.domain.emails;

/**
 * A selector for the email content loaded in the domain state.
 * Turns the map into a list for use in tables
 * @param {object} state The redux state of the application.
 * @returns An array of EmailContent objects.
 */
export const selectEmailContentList = createSelector(['via.domain.emails'], map => (map ? Object.values(map) : null));


// A dict object with a property key of: emailType and a property value of: { emailType:..., emailContent:... }.
const initialEmailContentState = {
};

const emailsReducer = createReducer(initialEmailContentState, {
  // Puts a user into the store.
  [putEmailContent]: (state, action) => {
    const emailContent = action.payload;

    return {
      ...state,
      [emailContent.emailType]: emailContent,
    };
  },

  [addDefaultContent]: (state, action) => {
    const defaultContent = action.payload;

    return {
      ...state,
      [defaultContent.emailType]: { ...state[defaultContent.emailType], default: defaultContent.emailContent }
    };
  },

  [putAllEmailContent]: (state, action) => {
    const allEmailContent = action.payload;
    return allEmailContent.reduce((newState, emailContent) => {
      newState[emailContent.emailType] = emailContent;// eslint-disable-line no-param-reassign
      return newState;
    }, { ...initialEmailContentState });
  },
});

export default emailsReducer;
